import FilledCartProduct from '../../../api/models/FilledCartProduct'

export function getProductsByFilledCart (filledCart, activeStore) {
  return filledCart
    .map(item => new FilledCartProduct(item))
    .map(item => {
      const product = activeStore.findProductById(item.getProductId())
      if (product) {
        product.count = item.getMaxAvailableQuantity()
        return product
      }
      return product
    })
    .filter(item => item !== undefined)
}
